import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { AccountContext } from 'components/AccountContext';
import React, { useEffect, useContext, useState, useMemo } from 'react';
import { Box, Button, Center, Flex, Grid, Image, SimpleGrid, Skeleton, Text } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';

function ProximasMensalidades(props) {
  const { theme, mensalidades, descricao_plano } = props;
  const [selectButton, setSelectButton] = useState(null);
  const anos = [...new Set(mensalidades.map((m) => new Date(m.data).getFullYear()))].sort((a, b) => b - a);
  const mensalidadesFiltradas = selectButton ? mensalidades.filter((m) => new Date(m.data).getFullYear() === selectButton) : mensalidades;
  const data_atual = new Date();
  const navigate = useNavigate();
  return (
    <>
      <Box>
        <Flex alignItems="auto" justifyContent="space-between" m={8} mb={4}>
          <Text color="#585858" fontWeight="bold" fontSize="lg">
            Mensalidades
          </Text>
        </Flex>

        <Box overflowX="auto" whiteSpace="nowrap" px={{ base: 4, md: 8 }} ml={'2%'}>
          <Flex gap={0} align="center" flexWrap="nowrap">
            <Button
              rounded="full"
              variant={selectButton === null ? 'solid' : 'outline'}
              color={selectButton === null ? theme?.fontcolor : theme?.background}
              bg={selectButton === null ? theme?.background : 'white'}
              onClick={() => setSelectButton(null)}
              borderColor={selectButton === null ? 'white' : theme?.background}
              minW="100px"
              fontSize="sm"
              m={2}
            >
              Todas
            </Button>

            {anos.map((ano) => (
              <Button
                key={ano}
                rounded="full"
                variant={selectButton === ano ? 'solid' : 'outline'}
                color={selectButton === ano ? theme?.fontcolor : theme?.background}
                bg={selectButton === ano ? theme?.background : 'white'}
                onClick={() => setSelectButton(ano)}
                borderColor={selectButton === ano ? 'white' : theme?.background}
                px={4}
                minW="100px"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                fontSize="sm"
                m={2}
              >
                {ano === new Date().getFullYear() ? 'Ano atual' : ano}
              </Button>
            ))}
          </Flex>
        </Box>
        <Box overflowX="auto" whiteSpace="nowrap" px={8}>
          {mensalidadesFiltradas?.length > 0 ? (
            mensalidadesFiltradas.map((mensalidade, index) => {
              const dataExtenso = new Date(mensalidade.data).toLocaleString('pt-BR', { month: 'long' });
              if (mensalidade?.excluido) return;
              return (
                <Box
                  key={index}
                  position="relative"
                  display="inline-block"
                  bg="#F3F3F3"
                  borderRadius="0.8em"
                  minW="180px"
                  maxW="220px"
                  mr={4}
                  p={4}
                  mb={'1em'}
                  onClick={() => {
                    if (!mensalidade.ativo) return;
                    navigate('/perfil/pagamento/pagar-parcela', {
                      state: {
                        theme,
                        mensalidade,
                        descricao_plano,
                      },
                    });
                  }}
                >
                  <Flex direction="column" gap={2} mb={2}>
                    <Flex justify="space-between" align="center">
                      <Text as="span" color="#888888" fontWeight="bold" fontSize="lg">
                        {dataExtenso.charAt(0).toUpperCase() + dataExtenso.slice(1)}
                      </Text>
                      <Text
                        as="span"
                        color="white"
                        fontWeight="bold"
                        fontSize="12px"
                        borderRadius="0.8em"
                        bg={mensalidade?.ativo === false ? theme.background : new Date(mensalidade.data) < new Date() ? '#D60000' : '#5AB2AE'}
                        px={3}
                        py={1}
                      >
                        {mensalidade?.ativo === false ? 'Paga' : new Date(mensalidade.data) < new Date() ? 'Vencida' : 'Aberta'}
                      </Text>
                    </Flex>
                    <Text color="#585858" fontSize="20px">
                      <Text
                        as="span"
                        fontWeight="bold"
                        color={mensalidade?.ativo === false ? theme.background : new Date(mensalidade.data) < new Date() ? '#D60000' : '#5AB2AE'}
                      >
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(parseFloat(mensalidade.valor))}
                      </Text>
                    </Text>
                  </Flex>

                  <Flex gap="2" flexWrap="wrap" mt="0.5em">
                    <Text color="#585858" fontSize="sm">
                      Plano:{' '}
                      <Text as="span" color="#888888" fontWeight="bold">
                        {descricao_plano.charAt(0).toUpperCase() + descricao_plano.slice(1).toLowerCase()}
                      </Text>
                    </Text>

                    <Text color="#585858" fontSize="sm">
                      Vencimento:{' '}
                      <Text as="span" color="#888888" fontWeight="bold">
                        {new Date(mensalidade.data).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: '2-digit'
                        })}
                      </Text>
                    </Text>
                  </Flex>
                </Box>
              );
            })
          ) : (
            <>
              <Text color="#585858" fontSize="sm">
                Não há próximas mensalidades disponíveis
              </Text>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}

function FormaPagamentoPlano(props) {
  const { theme, mensalidades, descricao_plano } = props;
}

function MensalidadeDetalhes() {
  const { setPage, user } = useContext(AccountContext);
  const state = useLocation();
  const { themeApp, mensalidades, descricao_plano } = state?.state;

  useEffect(() => {
    setPage('Mensalidades');
  }, [setPage]);

  return (
    <>
      <ChildHeader />

      <ProximasMensalidades theme={themeApp} mensalidades={mensalidades} descricao_plano={descricao_plano} />
      <FormaPagamentoPlano theme={themeApp} />
    </>
  );
}

export default MensalidadeDetalhes;
